<template>
  <div class="home-international-container">
    <div class="home-international-info-bg">
    </div>
    <div class="home-international-info-desc">
      <h1>{{ $t('home.safe.title') }}</h1>
      <h1>{{ $t('home.safe.title2') }}</h1>
      <h1>{{ $t('home.safe.title3') }}</h1>
      <div class="download">
        <h2>{{ $t('home.safe.download') }}</h2>
        <a href="https://apps.apple.com/app/id1671394841">
          <img :src="require('../imgs/ios_download.svg')" alt="ios_download">
        </a>
      </div>
      <img class="home-international-img-left" :src="require('../imgs/safa_left.svg')" alt="left-icon">
      <img class="home-international-img-right" :src="require('../imgs/safa_right.svg')" alt="right-icon">
    </div>
  </div>
</template>

<script>
export default {
  name: 'HomeSafety',
  components: {

  }
}
</script>

<style lang="less" scoped>
  .home-international-container {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 53.875rem;
    width: 100%;
    background-color: #F5F5F5;
    position: relative;
    .home-international-info-bg{
      position:absolute;
      z-index: 10;
      width: 66.375rem;
      height: 34.2rem;
      background: linear-gradient(225.24deg, #2AEA7B 7.55%, #00C4EE 50.47%, #0B94FE 92.5%);
      opacity: 0.4;
      border-radius: 4.111875rem;
    }
    .home-international-info-desc{
      position:absolute;
      z-index: 20;
      width: 66.375rem;
      height: 34.2rem;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      h1{
        font-family: 'PingFang SC';
        font-style: normal;
        font-weight: 600;
        font-size: 3.15rem;
        line-height: 150%;
        letter-spacing: -0.02em;
        color: #000000;
      }
      .download {
        position: absolute;
        background: #050505;
        border-radius: 2.7rem;
        width: 35.4375rem;
        height: 13.1625rem;
        z-index: 20;
        bottom: -6.5625rem;
        a{
          img{
            margin-top: 0.625rem;
            width: 10.125rem;
            height: 3.375rem;
          }
        }
        h2{
          font-family: 'PingFang SC';
          font-style: normal;
          font-weight: 600;
          font-size: 3.15rem;
          line-height: 150%;
          letter-spacing: -0.02em;
          color: #FFFFFF;
          margin-top: 2.0625rem;
        }
      }
      .home-international-img-left{
        position: absolute;
        left: -6.875rem;
        width: 13.75rem;
        height: 13.75rem;
      }
      .home-international-img-right{
        position: absolute;
        right: -6.5625rem;
        top: 10%;
        width: 13.25rem;
        height: 13.5rem;
      }
    }
  }
  @media only screen and (max-width: 500px) {
    .home-international-container {
      min-height: 253px;
      position: relative;
      .home-international-info-bg {
        width: 297.36px;
        height: 153.22px;
        border-radius: 18.4212px;
      }
      .home-international-info-desc {
        width: 297.36px;
        height: 153.22px;
        position:absolute;
        h1 {
          font-size: 14.112px;
        }
        .download {
          width: 158.76px;
          height: 58.97px;
          border-radius: 12.096px;
          bottom: -29.485px;
          a{
            img{
              margin-top: 3px;
              width: 45px;
              height: 15px;
            }
          }
          h2{
            font-size: 14.112px;
            margin-top: 9px;
          }
        }
        .home-international-img-left{
          left: -30.8px;
          width: 61.6px;
          height: 56px;
        }
        .home-international-img-right{
          right: -30.8px;
          top: 10%;
          width: 61.6px;
          height: 56px;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Home/subcomponents/HomeSafety.vue